export default "/images/fbd948edf4f0e6aee29026e6d3256c4a.avif";